import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import type { Inspection, InspectionStatus } from './inspections';

export function useTransition(inspectionId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { targetStatus: InspectionStatus; version: number; reason?: string }) =>
      api<Inspection>(`/inspections/${inspectionId}/transitions`, { method: 'POST', body: input, version: input.version }),
    onSuccess: (inspection) => {
      qc.setQueryData(['inspections', inspectionId], inspection);
      void qc.invalidateQueries({ queryKey: ['inspections'] });
    },
  });
}
